import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const NumberRequestAccessRight = {
  VIEW_NUMBER_REQUESTS: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
} satisfies Record<string, AuthenticationAccessRight>;
